import { PrimaryButton, SecondaryButton } from '@lib/common';
import { Modal, Space } from 'antd';
import styled from 'styled-components';
import { PublishScoreForm } from './publish-score-form.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledModal = styled(Modal).withConfig({
  displayName: "publish-score-modalcomponent__StyledModal",
  componentId: "sc-wdix9z-0"
})(["height:80vh;width:600px !important;margin-block:5em;.ant-modal-content{padding:16px;border-radius:16px;overflow:hidden;display:flex;flex-direction:column;}.ant-modal-header{border-bottom:none;flex-shrink:0;}.ant-modal-body{overflow-y:auto;flex:1;}.ant-modal-footer{flex-shrink:0;}"]);
export var PublishScoreModal = function PublishScoreModal(props) {
  var form = props.form,
      label = props.label,
      isModalVisible = props.isModalVisible,
      errorLabel = props.errorLabel,
      isDisabledPublishButton = props.isDisabledPublishButton,
      isLoadingPublishScore = props.isLoadingPublishScore,
      onCancelModal = props.onCancelModal,
      onContinue = props.onContinue,
      onFormValuesChange = props.onFormValuesChange;

  var renderPublishScoreFormContent = function renderPublishScoreFormContent() {
    return /*#__PURE__*/_jsx(PublishScoreForm, {
      form: form,
      label: label,
      onFormValuesChange: onFormValuesChange,
      onContinue: onContinue,
      errorLabel: errorLabel
    });
  };

  return /*#__PURE__*/_jsx(StyledModal, {
    open: isModalVisible,
    onCancel: onCancelModal,
    title: label.title,
    footer: /*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      size: "small",
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        onClick: onCancelModal,
        disabled: isLoadingPublishScore,
        children: label.cancel
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        size: "middle",
        onClick: onContinue,
        loading: isLoadingPublishScore,
        disabled: isDisabledPublishButton,
        children: label["continue"]
      })]
    }),
    children: renderPublishScoreFormContent()
  });
};